import bootstrap from '@zhenguo/vue-jssdk/bootstrap'
import getURLSearchParam from '@zhenguo/jssdk/base/url'
import installPagePlugins from '@/plugins'
import { installTheme } from '@/plugins/theme'
import App from './App'

const themeNative = getURLSearchParam('theme') === 'native'

if (themeNative) {
  window.LX_PAGE_CID = 'c_8ll1wjk5'
}

installTheme(themeNative).then(({ theme, themeNative }) => {
  const phxFrom = getURLSearchParam('phx_from') || ''
  bootstrap({
    App,
    installPagePlugins: installPagePlugins({
      theme,
      themeNative,
      fromActivity: !!phxFrom,
      phxFrom,
    }),
  })
})
